import React, { useState, useEffect, useRef } from "react";
import "./Shop.scss";
import ShopCard from "../../components/ShopCard/ShopCard";
import axios from "axios";
import { useParams } from "react-router-dom";

const Shop = () => {
  const [showAccordian, setShowAccordian] = useState(false);
  const [showSortDiv, setShowSortDiv] = useState(false);
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isSortActive, setIsSortActive] = useState(false);

  let { productId } = useParams();
  console.log(productId);

  const [sortOption, setSortOption] = useState("");
  const [showProduct, setShowProduct] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);

  const handleSortChange = (option) => {
    setSortOption(option);
  };

  const handleSizeChange = (size) => {
    setSelectedSizes((prevSizes) =>
      prevSizes.includes(size)
        ? prevSizes.filter((s) => s !== size)
        : [...prevSizes, size]
    );
    console.log(selectedSizes);
  };

  const handleColorChange = (color) => {
    setSelectedColors((prevColors) =>
      prevColors.includes(color)
        ? prevColors.filter((c) => c !== color)
        : [...prevColors, color]
    );
  };

  const filterAndSortProducts = () => {
    console.log(products);
    // let filteredProducts = products.filter(
    //   (product) =>
    //     (selectedSizes.length === 0 ||
    //       selectedSizes.includes(product?.sizeDetails?.size)) &&
    //     (selectedColors.length === 0 || selectedColors.includes(product.color))
    // );
    let filteredProducts = products.filter((product) => {
      // Check if any size in sizeDetails matches the selected sizes
      console.log(products);
      console.log("->>>>>", product?.sizeDetails);
      const sizeMatch =
        selectedSizes.length === 0 ||
        product?.sizeDetails?.some((sizeDetail) =>
          selectedSizes.includes(sizeDetail?.size)
        );

      // Check if the product color matches the selected colors
      const colorMatch =
        selectedColors.length === 0 || selectedColors.includes(product.color);

      return sizeMatch && colorMatch;
    });

    let sortedProducts = filteredProducts.sort((a, b) => {
      if (sortOption === "lowToHigh") {
        return a.price - b.price;
      } else if (sortOption === "highToLow") {
        return b.price - a.price;
      }
      return 0;
    });

    console.log("->>>>>>>>>>>>>>>>>", sortedProducts);

    setShowProduct(sortedProducts);

    console.log(showProduct);
  };

  const Accordian = () => {
    setShowAccordian(!showAccordian);
  };

  const fetchProducts = (page) => {
    productId = productId == undefined ? null : productId;
    const config = {
      url: `${
        process.env.REACT_APP_BASE_URL
      }api/allProducts/${productId}?page=${page}&limit=${20}`,
      method: "get",
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Hello");
        console.log(response?.data?.data);
        if (response?.data?.status) {
          const data = response?.data;
          setProducts((prevProducts) => [...prevProducts, ...data?.data]);
          setShowProduct((prevProducts) => [...prevProducts, ...data?.data]);
          setTotalPages(data.pagination.totalPages);
          setCurrentPage(data.pagination.currentPage);
        }
        if (!response?.data?.status) {
          if (response?.data?.response_code === 500) {
            // Handle error 500
          } else if (response?.data?.response_code === 404) {
            // Handle error 404
          }
        }
      })
      .catch((error) => {
        if (error?.response?.data?.response_code === 401) {
          // Handle token expiration
        } else {
          // Handle other errors
        }
      });
  };

  useEffect(() => {
    console.log();
    fetchProducts(1);
  }, [productId]);

  console.log({ totalPages, currentPage });

  const handleLoadMore = () => {
    if (currentPage < totalPages) {
      fetchProducts(currentPage + 1);
    }
  };

  useEffect(() => {
    filterAndSortProducts();
  }, [sortOption, selectedSizes, selectedColors]);

  const loadMoreRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting && !loading && currentPage <= totalPages) {
          handleLoadMore();
        }
      },
      { threshold: 1.0 }
    );

    if (loadMoreRef.current) {
      observer.observe(loadMoreRef.current);
    }

    return () => {
      if (loadMoreRef.current) {
        observer.unobserve(loadMoreRef.current);
      }
    };
  }, [currentPage, totalPages, loading]);

  return (
    <>
      <div className="shop-main">
        <div className="shop-main-outer">
          <div className="shop-main-inner row">
            <div className="shop-section-1 col-md-3">
              <div className="section-1-outer">
                {/* heading */}
                <div className="section-1-category">
                  <div className="category-body" style={{ color: "#332C1F" }}>
                    <h4>ALL SHIRTS</h4>
                  </div>
                </div>

                {/* button container */}
                <div className="filter-head-container">
                  {/* filter button */}
                  <div className="filter-head">
                    <button
                      className={`filter-btn ${
                        isFilterActive ? "checked" : ""
                      }`}
                      onClick={() => {
                        Accordian();
                        setIsFilterActive(!isFilterActive);
                      }}
                    >
                      Filters
                    </button>
                  </div>

                  {/* sort button */}
                  <div className="sort-btn-container">
                    <button
                      className={`sort-btn ${isSortActive ? "checked" : ""}`}
                      onClick={() => {
                        setShowSortDiv(!showSortDiv);
                        setIsSortActive(!isSortActive);
                      }}
                      styles={showSortDiv && { background: "red" }}
                    >
                      Sort
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* filter container */}
            {showAccordian && (
              <div className="fiter-close">
                {/* Size section */}
                <div className="section-1-size">
                  <div className="size-head">
                    <h4>Size</h4>
                  </div>

                  <div className="size-body">
                    {["XS", "S", "M", "L", "XL", "XXL"].map((size) => (
                      <div className="checkboxs" key={size}>
                        <input
                          className="cheked"
                          type="checkbox"
                          value={size}
                          checked={selectedSizes.includes(size)}
                          onChange={() => handleSizeChange(size)}
                        />
                        <label>{size}</label>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Color section */}
                <div className="section-1-color">
                  <div className="color-head mt-2">
                    <h4 className="">Colors</h4>
                  </div>

                  <div className="color-body">
                    {["RED", "BLUE", "GREEN", "YELLOW", "ORANGE"].map(
                      (color) => (
                        <div className="checkboxs" key={color}>
                          <input
                            type="checkbox"
                            value={color}
                            className={`checkmark-${color}`}
                            checked={selectedColors.includes(color)}
                            onChange={() => handleColorChange(color)}
                          />
                          <label>{color}</label>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* sort container */}
            {showSortDiv && (
              <div className="fiter-close">
                <div className="section-1-price">
                  <div className="row gap-2 filter-body">
                    <h4 className="col-12">Sort By</h4>

                    <div className="chek-boxes row">
                      <div className="form-check col-5 mx-3">
                        <input
                          className="form-check-input "
                          type="checkbox"
                          value="lowToHigh"
                          checked={sortOption === "lowToHigh"}
                          onChange={() => handleSortChange("lowToHigh")}
                          id="flexCheckLowToHigh"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckLowToHigh"
                        >
                          Price: Low To High
                        </label>
                      </div>

                      <div className="form-check col-5">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="highToLow"
                          checked={sortOption === "highToLow"}
                          onChange={() => handleSortChange("highToLow")}
                          id="flexCheckHighToLow"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckHighToLow"
                        >
                          Price: High To Low
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="productss">
              {showProduct?.map((product, index) => (
                <div
                  // className=" col-md-3 col-sm-4 flex-item "
                  key={index}
                  style={{ cursor: "pointer" }}
                >
                  <ShopCard product={product} />
                </div>
              ))}

              <div
                ref={loadMoreRef}
                style={{
                  height: "1px",
                  margin: "1px 0",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
// done
export default Shop;
